import { type ReactNode, useState } from 'react';
import { SectionHeader } from '@/shared/ui/SectionHeader';
import styles from './CollapsibleSection.module.css';

interface CollapsibleSectionProps {
  title: string;
  count: number;
  onClear: () => void;
  defaultCollapsed?: boolean;
  children: ReactNode;
}

export default function CollapsibleSection({
  title,
  count,
  onClear,
  defaultCollapsed = false,
  children,
}: CollapsibleSectionProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div className={styles.section}>
      <SectionHeader
        title={title}
        count={count}
        onClear={onClear}
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
      />
      <div className={styles.sectionBody} data-collapsed={collapsed}>
        <div className={styles.sectionBodyInner}>{children}</div>
      </div>
    </div>
  );
}
